import React, { useState } from 'react'
import { Col, Container, Row, Navbar, Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faMapMarkedAlt, faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
import { faFacebookSquare, faInstagram, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import logo from "../Images/logo.png";
import "./Css/Header.css";


const Header = () => {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const handleLinkClick = () => {
    setExpanded(false); // Collapse the navbar
  };
  return (
    <div className='header-section'>      
      <div className='inner-header'>
        <div className='top-header'>
          <Container >
          <Row className='contact-info d-flex align-items-stretch'>
            <Col xs="4">
              <div className='address d-flex align-items-center gap-2 justify-content-center'>
                <FontAwesomeIcon icon={faMapMarkedAlt} />
                Madhapur, Hyderabad, Telangana
              </div>
            </Col>
            <Col xs="3">
              <div className='phone d-flex align-items-center gap-2 justify-content-center'>
                <FontAwesomeIcon icon={faPhoneVolume} />
                +91 89777 81366 / 69
              </div>
            </Col>
            <Col xs="3">
              <div className='email d-flex align-items-center gap-2 justify-content-center'>
                <FontAwesomeIcon icon={faEnvelope} />
                srimahacaterers.dm@gmail.com
              </div>
            </Col>
            <Col xs="2">
              <div className='social-media d-flex align-items-center gap-3 justify-content-center'>
                <a href='https://www.facebook.com/share/1Bv3XMoRt7/?mibextid=wwXIfr' target='_blank' rel='noreferrer' title='Facebook'>
                  <FontAwesomeIcon icon={faFacebookSquare} size='2x' />
                </a>
                <a href='https://www.instagram.com/srimahacaterers?igsh=ZDRzejc2ajI4azlq' target='_blank' rel='noreferrer' title='Instagram'>
                  <FontAwesomeIcon icon={faInstagram} size='2x' />
                </a>
                <a href='https://x.com/srimahacaterers?s=11' target='_blank' rel='noreferrer' title='Twitter'>
                  <FontAwesomeIcon icon={faTwitter} size='2x' />
                </a>
                <a href='https://youtube.com/@srimahacaterers?si=FjldBFGuyyZ-l3JV' target='_blank' rel='noreferrer' title='Youtube'>
                  <FontAwesomeIcon icon={faYoutube} size='2x' />
                </a>
              </div>
            </Col>
          </Row>

          </Container>
      </div>
      <div className='bottom-header'>
        <Container>
          <Row className='d-flex '>
            <Col xs="4">
              <div className='logo'>
              <Navbar.Brand as={Link} to="/">
                <img src={logo} alt="Sri Maha Caterers" />
              </Navbar.Brand>
              </div>
            </Col>
            <Col xs="8">
              <Navbar expand="lg" expanded={expanded} onToggle={setExpanded} className="d-flex align-items-center justify-content-between">
                <Navbar.Toggle aria-controls="basic-navbar-nav" className="ml-auto" />
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="me-auto d-flex align-items-center justify-content-center gap-4">
                    <Nav.Link as={Link} to="/" active={location.pathname === "/"} onClick={handleLinkClick}>
                      Home
                    </Nav.Link>
                    <Nav.Link as={Link} to="/services" active={location.pathname === "/services"} onClick={handleLinkClick}>
                      Services
                    </Nav.Link>
                    <Nav.Link as={Link} to="/about-us" active={location.pathname === "/about-us"} onClick={handleLinkClick}>
                      About Us
                    </Nav.Link>
                    <Nav.Link as={Link} to="/blogs" active={location.pathname === "/blogs"} onClick={handleLinkClick}>
                      Blogs
                    </Nav.Link>
                    <Nav.Link as={Link} to="/gallery" active={location.pathname === "/gallery"} onClick={handleLinkClick}>
                      Gallery
                    </Nav.Link>
                    <Nav.Link as={Link} to="/faq" active={location.pathname === "/faq"} onClick={handleLinkClick}>
                      FAQ
                    </Nav.Link>
                    <Nav.Link as={Link} to="/contact" active={location.pathname === "/contact"} onClick={handleLinkClick} className="btn-style gallery-btn contact-btn">
                      Contact
                    </Nav.Link>
                  </Nav>
                </Navbar.Collapse>
              </Navbar>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  </div>   
  )
}

export default Header